import {Component, Element, State, h, Prop} from '@stencil/core';

@Component({
  tag: 'uiaas-search-widget-contact-sales',
  styleUrl: 'contact-sales-widget.scss',
  shadow: true
})
export class ContactSalesWidget {

  @Prop() readonly country: string = 'us';
  @Prop() readonly language: string = 'en';
  @Prop() readonly link: string;
  @Prop() readonly appName: string;
  @Prop() readonly anchorTarget: string = '';

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  private makeLabel() {
      const language = this.language.toLowerCase();

      switch (language) {
      default:
      case 'en':
        return ['Contact Sales', 'Start your sales inquiry online and an expert will connect with you.', 'Get a Quote'];
      case 'de':
        return ['Vertrieb kontaktieren', 'Starten Sie Ihre Verkaufsanfrage online und ein Experte wird sich mit Ihnen in Verbindung setzen.', 'Angebot erhalten'];
      case 'pl':
        return ['Kontakt z działem sprzedaży', 'Wyślij zapytanie sprzedażowe online, a skontaktuje się z Tobą ekspert.', 'Uzyskaj ofertę'];
      case 'fr':
        return ['Contacter le service commercial', 'Commencez votre demande de vente en ligne et un expert vous contactera.', 'Obtenir un devis'];
      case 'ru':
        return ['Свяжитесь с отделом продаж', 'Сформируйте коммерческий запрос онлайн и наш специалист свяжется с Вами.', 'Получить коммерческое предложение'];
      case 'nl':
        return ['Neem contact op met ons verkoopteam', 'Dien online uw vragen in bij ons verkoopteam, een specialist neemt contact met u op.', 'Offerte aanvragen'];
      case 'it':
        return ['Contatta il reparto vendite', 'Invia online le tue domande sulla vendita: sarai contattato da un esperto.', 'Ottieni un preventivo'];
      case 'sv':
        return ['Kontakta säljare', 'Starta din säljfråga online så kontaktar en expert dig.', 'Få en offert'];
      case 'es':
        return ['Contactar con ventas', 'Comienza tu consulta de ventas on-line y un experto se pondrá en contacto contigo.', 'Obtener un presupuesto'];
      case 'ja':
        return ['販売チームへのご連絡', '貴社の販売照会をオンラインで始めれば、貴社の国のエキスパートとつながります！', '見積もり依頼'];
      case 'zh':
        return ['联系销售', '开始在线销售咨询，专家将与您联系。', '获取报价'];
      case 'fi':
        return ['Ota yhteyttä myyntiin', 'Aloita myyntitiedustelu verkossa. Asiantuntijamme ottaa sinuun yhteyttä.', 'Pyydä tarjous'];
      }
  }

  private getLink(): string {
      const supportLink = this.link ? this.link :
        `https://se.com/${this.country}/${this.language}/work/support/customer-care/contact-sales.jsp`;
  
      return supportLink;
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      this.tabName = closestTabEl?.['tabName'];
  }

  render() {
      const labels = this.makeLabel();
      const link = this.getLink();
      return <uiaas-search-cta-widget-v2
        anchor-target={this.anchorTarget}
        tab-name= {this.tabName}
        header={labels[0]}
        content={labels[1]}
        url={link}
        buttonText={labels[2]}
        event-category='Contact Sales'
      >
        <qds-icon
          slot="icon"
          size="large" 
          name="headset"
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget-v2>;
  }
}
